export default "__VITE_ASSET__DfM8YDnS__"